$(document).ready(function () {
    let openApplicationPopupButton = $(".cle-open-application-popup");
    // Don't run if there's no open-application-form button
    if (!openApplicationPopupButton.length) {
        return;
    }

    openApplicationPopupButton.on("click", function (e) {
        e.preventDefault();
        $("#job-application-popup").find(".elementor-message").remove();
        let jobID = $(this).data("jobId");
        let jobTitle = $(this).data("job-title");

        let jobDescription = null;
        if($(this).data("jobDescription")) {
            jobDescription = JSON.parse($(this).data("jobDescription"));
            jobDescription = jobDescription.replace(/\r\n\r\n/g, "<br>");
        }
        let studioID = $(this).data("studioId");
        let studioTitle = $(this).data("studio-title");
        let studioLocation = $(this).data("studio-location");

        $("#form-field-field_studio_id").val(studioID);
        $("#form-field-field_studio_name").val(studioTitle);
        $("#form-field-field_studio_location").val(studioLocation);
        $("#form-field-field_job_id").val(jobID);
        $("#form-field-field_job_title").val(jobTitle);
        if(jobDescription) {
            $('.job-application-popup__job-description').html(jobDescription);
            $(".job-application-popup__job-title span").html(' ' + studioTitle);
        } else {
            $(".job-application-popup__job-title span").html(' ' + jobTitle);
        }
        showFormFields();
        $("#job-application-popup").show();
        setTimeout(function () {
            $("#job-application-popup").addClass("visible");
        }, 100);

        $("#close-job-application-popup").on("click", closeJobApplicationPopup);
    });

    const closeJobApplicationPopup = () => {
        setTimeout(function () {
            $("#job-application-popup").hide();
        }, 100);
        $("#job-application-popup").removeClass("visible");
    };

    const hideFormFields = () => {
        $(".elementor-form-fields-wrapper").fadeOut();
    };

    const showFormFields = () => {
        $(".elementor-form-fields-wrapper").fadeIn();
    };

    $(document).ajaxSuccess(function (event, request, settings, response) {
        if (response.success) {
            hideFormFields();
        }
    });
});
